import { render, staticRenderFns } from "./RuleDisplayPreview.vue?vue&type=template&id=2f928666"
import script from "./RuleDisplayPreview.vue?vue&type=script&lang=js"
export * from "./RuleDisplayPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports